import React from "react";
import { Tooltip, styled, tooltipClasses } from "@mui/material";
import { ListGroup } from "react-bootstrap";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
    padding: theme.spacing(1),
  },
}));

const TestSuiteMetrics = ({
  passPercentage,
  executionPercentage,
  totalTestCases,
}) => {
  return (
    <HtmlTooltip
      id="test-case-tooltip"
      title={
        <ListGroup variant="flush">
          <ListGroup.Item
            style={{ whiteSpace: "nowrap", color: "var(--primary-color)" }}
          >
            TCs Executed: {executionPercentage}%
          </ListGroup.Item>
          <ListGroup.Item style={{ whiteSpace: "nowrap", color: "green" }}>
            TCs Pass: {passPercentage}%
          </ListGroup.Item>
        </ListGroup>
      }
    >
      <span style={{ cursor: "pointer" }}>{totalTestCases}</span>
    </HtmlTooltip>
  );
};

export default TestSuiteMetrics;
